import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'my-btn-generic',
  templateUrl: './my-btn-generic.component.html',
  styleUrls: ['./my-btn-generic.component.css', '../../app.component.scss']
})
export class MyBtnGenericComponent implements OnInit {

  @Input('displayData') set _displayData(d: any) {
    this.displayData = d
    this.setViewData(d)
  }

  displayData: any

  tableLayout = ""
  iconName: string|undefined = undefined

  constructor() { }

  ngOnInit(): void {}

  setViewData(displayData: any) {
    if (!displayData) return 
    this.iconName = displayData.iconName
    if (displayData?.title && displayData?.subTitle) {
      this.tableLayout = `
      <table style="width:100%;">
        <tr>
          <td>${displayData.title}</td>
          <td style="text-align:end;">${displayData.selectedValue ? displayData.selectedValue : "wählen ..."}</td>
        </tr>
        <tr>
          <td>${displayData.subTitle}</td>
          <td></td>
        </tr>
      </table>
      `
    } else {
      this.tableLayout = `
      <table style="width:100%;">
        <tr>
          <td>${displayData.title ? displayData.title : "Unkown"}</td>
          <td style="text-align:end;">${(displayData.selectedValue == "" || displayData.selectedValue) ? displayData.selectedValue : "wählen ..."}</td>
        </tr>
      </table>
      `
    }
  } 
}
